import React, { useState, useContext } from 'react';
import { Popover, PopoverBody } from 'reactstrap';

import Checkbox from '../Checkbox';
import communicationsActions from '../../../actions/communications.actions';
import CommunicationsDispatch from '../../../contexts/communications.dispatch';

import style from './CommunicationsFilter.module.css';

const CommunicationsFilter = React.memo(() => {
  const dispatch = useContext(CommunicationsDispatch);
  const [opened, setOpened] = useState(false);
  const [selectedAll, setSelectedAll] = useState(true);
  const [filter, setFilter] = useState({
    date: {
      thirtyDays: false,
      sixtyDays: false,
      ninetyDays: false,
      oneYear: true,
      all: false,
    },
    category: {
      documents: true,
      endorsements: true,
      bindRequests: true,
      otherService: true,
      policyCancel: true,
      policyEvents: true,
    },
  });

  const handleDateFilter = forFilter => {
    let filterDate;
    switch (forFilter) {
      case '30':
        if (filter.date.thirtyDays) return;
        filterDate = Object.assign({}, filter, {
          date: {
            thirtyDays: !filter.date.thirtyDays,
            sixtyDays: false,
            ninetyDays: false,
            oneYear: false,
            all: false,
          },
        });
        break;
      case '60':
        if (filter.date.sixtyDays) return;
        filterDate = Object.assign({}, filter, {
          date: {
            thirtyDays: false,
            sixtyDays: !filter.date.sixtyDays,
            ninetyDays: false,
            oneYear: false,
            all: false,
          },
        });
        break;
      case '90':
        if (filter.date.ninetyDays) return;
        filterDate = Object.assign({}, filter, {
          date: {
            thirtyDays: false,
            sixtyDays: false,
            ninetyDays: !filter.date.ninetyDays,
            oneYear: false,
            all: false,
          },
        });
        break;
      case 'year':
        if (filter.date.oneYear) return;
        filterDate = Object.assign({}, filter, {
          date: {
            thirtyDays: false,
            sixtyDays: false,
            ninetyDays: false,
            oneYear: !filter.date.oneYear,
            all: false,
          },
        });
        break;
      case 'all':
        if (filter.date.all) return;
        filterDate = Object.assign({}, filter, {
          date: {
            thirtyDays: false,
            sixtyDays: false,
            ninetyDays: false,
            oneYear: false,
            all: !filter.date.all,
          },
        });
        break;
      default:
        break;
    }

    setFilter(filterDate);
    dispatch({
      type: communicationsActions.COMMUNICATIONS_FILTER_CHANGE_SUCCESS,
      date: filterDate.date,
      category: filterDate.category,
    });
  };

  const handleTypeFilter = forFilter => {
    let filterType = {};

    switch (forFilter) {
      case 'documents':
        filterType = Object.assign({}, filter, {
          category: {
            documents: !filter.category.documents,
            endorsements: filter.category.endorsements,
            bindRequests: filter.category.bindRequests,
            otherService: filter.category.otherService,
            policyCancel: filter.category.policyCancel,
            policyEvents: filter.category.policyEvents,
          },
        });
        break;
      case 'endorsements':
        filterType = Object.assign({}, filter, {
          category: {
            documents: filter.category.documents,
            endorsements: !filter.category.endorsements,
            bindRequests: filter.category.bindRequests,
            otherService: filter.category.otherService,
            policyCancel: filter.category.policyCancel,
            policyEvents: filter.category.policyEvents,
          },
        });
        break;
      case 'bindRequests':
        filterType = Object.assign({}, filter, {
          category: {
            documents: filter.category.documents,
            endorsements: filter.category.endorsements,
            bindRequests: !filter.category.bindRequests,
            otherService: filter.category.otherService,
            policyCancel: filter.category.policyCancel,
            policyEvents: filter.category.policyEvents,
          },
        });
        break;
      case 'otherService':
        filterType = Object.assign({}, filter, {
          category: {
            documents: filter.category.documents,
            endorsements: filter.category.endorsements,
            bindRequests: filter.category.bindRequests,
            otherService: !filter.category.otherService,
            policyCancel: filter.category.policyCancel,
            policyEvents: filter.category.policyEvents,
          },
        });
        break;
      case 'policyCancel':
        filterType = Object.assign({}, filter, {
          category: {
            documents: filter.category.documents,
            endorsements: filter.category.endorsements,
            bindRequests: filter.category.bindRequests,
            otherService: filter.category.otherService,
            policyCancel: !filter.category.policyCancel,
            policyEvents: filter.category.policyEvents,
          },
        });
        break;
      case 'policyEvents':
        filterType = Object.assign({}, filter, {
          category: {
            documents: filter.category.documents,
            endorsements: filter.category.endorsements,
            bindRequests: filter.category.bindRequests,
            otherService: filter.category.otherService,
            policyCancel: filter.category.policyCancel,
            policyEvents: !filter.category.policyEvents,
          },
        });
        break;
      default:
        break;
    }

    if (
      filterType.category.documents &&
      filterType.category.endorsements &&
      filterType.category.bindRequests &&
      filterType.category.otherService &&
      filterType.category.policyCancel &&
      filterType.category.policyEvents
    ) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }

    setFilter(filterType);

    dispatch({
      type: communicationsActions.COMMUNICATIONS_FILTER_CHANGE_SUCCESS,
      date: filterType.date,
      category: filterType.category,
    });
  };

  const handleFilterToggle = () => {
    setOpened(!opened);
  };

  const handleSelectAll = event => {
    event.preventDefault();

    const filterType = Object.assign({}, filter, {
      category: {
        documents: !selectedAll,
        endorsements: !selectedAll,
        bindRequests: !selectedAll,
        otherService: !selectedAll,
        policyCancel: !selectedAll,
        policyEvents: !selectedAll,
      },
    });

    setFilter(filterType);

    setSelectedAll(!selectedAll);

    dispatch({
      type: communicationsActions.COMMUNICATIONS_FILTER_CHANGE_SUCCESS,
      date: filterType.date,
      category: filterType.category,
    });
  };

  return (
    <>
      <a
        className={style.filterLink}
        id="communications-filter"
        href="#filter"
        onClick={event => event.preventDefault()}
      >
        <span>Filter</span>
        <span className={`${style.arrow} ${opened && style.up}`} />
      </a>
      <Popover
        trigger="legacy"
        placement="bottom"
        isOpen={opened}
        target="communications-filter"
        toggle={handleFilterToggle}
        offset={-60}
        fade={false}
        className={style.filter}
      >
        <PopoverBody className={style.filterBody}>
          <div className={style.header}>Date: </div>
          <ul>
            <li>
              30 days
              <Checkbox
                checked={filter.date.thirtyDays}
                onChange={() => handleDateFilter('30')}
              />
            </li>
            <li>
              60 days
              <Checkbox
                checked={filter.date.sixtyDays}
                onChange={() => handleDateFilter('60')}
              />
            </li>
            <li>
              90 days
              <Checkbox
                checked={filter.date.ninetyDays}
                onChange={() => handleDateFilter('90')}
              />
            </li>
            <li>
              1 year
              <Checkbox
                checked={filter.date.oneYear}
                onChange={() => handleDateFilter('year')}
              />
            </li>
            <li>
              All Dates
              <Checkbox
                checked={filter.date.all}
                onChange={() => handleDateFilter('all')}
              />
            </li>
          </ul>
          <div className={style.header}>
            Activity type:
            <a onClick={handleSelectAll} href="#toggle">
              {selectedAll ? 'Deselect all' : 'Select all'}
            </a>
          </div>
          <ul>
            <li>
              Documents
              <Checkbox
                checked={filter.category.documents}
                onChange={() => handleTypeFilter('documents')}
              />
            </li>
            <li>
              Endorsements
              <Checkbox
                checked={filter.category.endorsements}
                onChange={() => handleTypeFilter('endorsements')}
              />
            </li>
            <li>
              Bind Requests
              <Checkbox
                checked={filter.category.bindRequests}
                onChange={() => handleTypeFilter('bindRequests')}
              />
            </li>
            <li>
              Other Service Requests
              <Checkbox
                checked={filter.category.otherService}
                onChange={() => handleTypeFilter('otherService')}
              />
            </li>
            <li>
              Policy Cancel/ERP Requests
              <Checkbox
                checked={filter.category.policyCancel}
                onChange={() => handleTypeFilter('policyCancel')}
              />
            </li>
            <li>
              Policy Events
              <Checkbox
                checked={filter.category.policyEvents}
                onChange={() => handleTypeFilter('policyEvents')}
              />
            </li>
          </ul>
        </PopoverBody>
      </Popover>
    </>
  );
});

CommunicationsFilter.propTypes = {};

export default CommunicationsFilter;
